import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  public isLoading = false;
  constructor(private spinnerService: SpinnerService) {}

  ngOnInit() {
    this.spinnerService.enableSpinner.subscribe(res => {
      this.isLoading = res;
    });
  }
}
